<template>
  <div class="ProductExistAlso" v-if="productChoiceData.length > 1">
    <span>Existe aussi en:</span>
    <select name="capacity" @change="updateProduct">
      <option
        v-for="(ProductSelect, index) in productChoiceData"
        :value="ProductSelect.url"
        :id="ProductSelect.id"
        :key="index"
        >{{ ProductSelect.label }}</option
      >
    </select>
  </div>
</template>

<script>
import "@/includes/Product/ProductExistAlso/ProductExistAlso.scss";

export default {
  name: "ProductExisteAlso",

  data() {
    return {
      productChoiceData: this.productChoice,
    };
  },

  props: {
    productChoice: Array,
    cardsDisplay: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    updateProduct(event) {
      let id = event.target.id;
      let url = event.target.value;
      if (this.cardsDisplay) {
        this.$emit("ProductExistAlso::updateProduct", id);
      } else {
        window.location.replace(url);
      }
    },
  },
};
</script>
